module.exports = __webpack_public_path__ + "img/edit_close.d4e23a4f.svg";